import { useCallback } from "react";

import { useProductRoomI18nFormModelContext } from "../../../../_context";

export const useRoomI18nName = () => {
	const { viewModel, onSetViewModel } = useProductRoomI18nFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
